module.exports = __webpack_public_path__ + "static/media/Rider_Black.f8b596c7.svg";